import { useState } from "react";
import { Link } from "react-router";
import { mensagemDeErro, novaChave, rpc } from "../../lib/rpc";
import { localPorCodigo, produtoPorCodigo } from "../../lib/leitura";
import { sinalConcluido, sinalErro, sinalOk } from "../../lib/sinais";
import { fmtNum } from "../../lib/formato";
import { LeituraCodigo } from "../../componentes/LeituraCodigo";
import { AlertaErro } from "../../componentes/Alerta";
import { Botao, Campo, Escolha } from "../../componentes/ui";
import { AbasEntrada } from "./AbasEntrada";

const MOTIVOS = ["Recebimento", "Devolução de cliente", "Ajuste de estoque", "Outro"];

/** Entrada avulsa bipando: posição, produto e quantidade (estoque que entra sem nota). A aba ao lado digita o SKU. */
export default function Entrada() {
  const [posicao, setPosicao] = useState<string | null>(null);
  const [produto, setProduto] = useState<{ codigo: string; nome: string } | null>(null);
  const [qtd, setQtd] = useState("1");
  const [motivo, setMotivo] = useState(MOTIVOS[0]);
  const [detalhe, setDetalhe] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [lampejo, setLampejo] = useState(0);

  async function leitura(codigo: string) {
    setOk(null);
    if (!posicao) {
      const local = await localPorCodigo(codigo);
      if (!local) { sinalErro(); return setErro("Posição não cadastrada neste depósito"); }
      sinalOk(); setLampejo((n) => n + 1);
      return setPosicao(local.codigo);
    }
    const p = await produtoPorCodigo(codigo);
    if (!p) { sinalErro(); return setErro("Código não cadastrado"); }
    sinalOk(); setLampejo((n) => n + 1);
    setProduto({ codigo, nome: p.nome });
  }

  async function gravar() {
    if (!posicao || !produto) return;
    setOcupado(true);
    try {
      const r = await rpc<{ ok: boolean; saldo?: number; mensagem?: string }>("wms_entrada", {
        p_codigo_posicao: posicao, p_codigo_produto: produto.codigo, p_quantidade: Number(qtd),
        p_motivo: detalhe.trim() ? `${motivo}: ${detalhe.trim()}` : motivo, p_idem: novaChave(),
      });
      if (!r.ok) { sinalErro(); return setErro(r.mensagem ?? "Entrada recusada"); }
      sinalConcluido();
      setOk(`Entrada de ${qtd} ${produto.nome} em ${posicao}. Saldo agora: ${fmtNum(r.saldo)}`);
      setProduto(null);
      setQtd("1");
    } catch (e) {
      setErro(mensagemDeErro(e));
    } finally {
      setOcupado(false);
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <AlertaErro mensagem={erro} onFechar={() => setErro(null)} />
      <h1 className="font-sinal text-3xl font-bold">Entrada avulsa</h1>
      {!posicao && <AbasEntrada />}
      {ok && <p className="rounded-md bg-ok-claro px-3 py-2 font-semibold text-ok">{ok}</p>}
      {posicao && (
        <div className="flex items-center justify-between rounded-lg border-2 border-tinta bg-chapa px-4 py-3">
          <span className="font-sinal text-4xl font-bold">{posicao}</span>
          <Botao variante="fantasma" onClick={() => { setPosicao(null); setProduto(null); }}>Trocar</Botao>
        </div>
      )}
      {produto ? (
        <section className="flex flex-col gap-3 rounded-lg border-2 border-aco bg-chapa p-4">
          <p className="text-xl font-semibold">{produto.nome}</p>
          <Campo rotulo="Quantidade" type="number" inputMode="numeric" min={1} value={qtd} onChange={(e) => setQtd(e.target.value)} />
          <Escolha rotulo="Motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)}>
            {MOTIVOS.map((m) => <option key={m}>{m}</option>)}
          </Escolha>
          <Campo rotulo="Detalhe (nota, pedido, observação)" value={detalhe} onChange={(e) => setDetalhe(e.target.value)} />
          <div className="flex gap-2">
            <Botao variante="secundario" onClick={() => setProduto(null)}>Voltar</Botao>
            <Botao variante="confirmar" grande className="flex-1" disabled={ocupado || Number(qtd) <= 0} onClick={() => void gravar()}>Dar entrada</Botao>
          </div>
        </section>
      ) : (
        <LeituraCodigo rotulo={posicao ? "Bipe o produto que vai entrar" : "Bipe a posição onde o produto vai ficar"} onLeitura={leitura} desabilitado={ocupado} lampejo={lampejo} />
      )}
      <Link to="/estoque" className="text-center font-semibold underline">Voltar</Link>
    </div>
  );
}
